"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageSDK = void 0;
var ImageSDKConfig_1 = require("./ImageSDKConfig");
// https://github.com/wix-private/santa-core/tree/master/image-client-api
var imageClientSDK_1 = require("image-client-api/dist/imageClientSDK");
var ImageDescriptor_1 = require("./ImageDescriptor");
/**
 * Wrapper class for wix image client API
 */
var ImageSDK = /** @class */ (function () {
    function ImageSDK(image, config) {
        if (config === void 0) { config = {}; }
        this.config = config;
        var imgDescr = new ImageDescriptor_1.ImageDescriptor(image);
        this.image = imgDescr.getFullImageDescriptor();
    }
    ImageSDK.prototype.getScaledUrl = function (scaleType) {
        if (scaleType === void 0) { scaleType = ImageSDKConfig_1.ImageScaleType.FILL; }
        var _a = this.image, sourceHeight = _a.sourceHeight, sourceWidth = _a.sourceWidth, relativeUrl = _a.relativeUrl, targetHeight = _a.targetHeight, targetWidth = _a.targetWidth;
        switch (scaleType) {
            case ImageSDKConfig_1.ImageScaleType.FIT:
                // https://github.com/wix-private/santa-core/blob/184f20d8c421f66c2315950b921b650d739453e7/image-client-api/src/sdk/index.js#L18
                return imageClientSDK_1.getScaleToFitImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, this.config);
            case ImageSDKConfig_1.ImageScaleType.CROP:
                throw new Error('Not implemented method getCropImageDescriptor');
            case ImageSDKConfig_1.ImageScaleType.FILL:
            default:
                return imageClientSDK_1.getScaleToFillImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, this.config);
        }
    };
    ImageSDK.prototype.getCropURL = function (image, options) {
        var sourceHeight = image.sourceHeight, sourceWidth = image.sourceWidth, relativeUrl = image.relativeUrl, targetHeight = image.targetHeight, targetWidth = image.targetWidth, cropX = image.cropX, cropY = image.cropY, cropWidth = image.cropWidth, cropHeight = image.cropHeight;
        return imageClientSDK_1.getCropImageURL(relativeUrl, sourceWidth, sourceHeight, cropX, cropY, cropWidth, cropHeight, targetWidth, targetHeight, options);
    };
    return ImageSDK;
}());
exports.ImageSDK = ImageSDK;
//# sourceMappingURL=ImageSDK.js.map